module.exports = __webpack_public_path__ + "img/appAsset-brand--GoogleLogo.673248cc.svg";